export default __webpack_public_path__ + "static/media/baby.96c9cfed.png";